/**
 * @generated SignedSource<<71f648f82da66c70e0bba44f4b95aa55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MATAcquisitionChannelUtmSourceFilter = {
  search?: string | null;
};
export type MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery$variables = {
  filters?: MATAcquisitionChannelUtmSourceFilter | null;
};
export type MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery$data = {
  readonly acquisitionChannelUtmSources: ReadonlyArray<string>;
};
export type MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery = {
  response: MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery$data;
  variables: MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      }
    ],
    "kind": "ScalarField",
    "name": "acquisitionChannelUtmSources",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed9685a76532573e6e39dd5c415e2c10",
    "id": null,
    "metadata": {},
    "name": "MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery",
    "operationKind": "query",
    "text": "query MATAcquisitionChannelUtmSourcesSearchOverlayField_acquisitionChannelUtmSourcesQuery(\n  $filters: MATAcquisitionChannelUtmSourceFilter\n) {\n  acquisitionChannelUtmSources(filters: $filters)\n}\n"
  }
};
})();

(node as any).hash = "75ee0bd74f7676f2db3ef5552238cc42";

export default node;
